import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { SummaryColumns } from "@repo/utils";
import { useEstimateEditorSettings, useEstimateStructure, useEstimateTableSettings } from "@tools";
import {
  CostCell,
  HoursCell,
  RateCell,
  TimeCell,
  TeamMembersCell,
} from "./cells";
import {
  CompanyCostCell,
  CompanyUnitCostCell,
  ProfitabilityCell,
  ProfitCell
} from "../profitabilityCells";

export const ColumnFactory = observer(({
  element,
  displayClientCellContent,
  displayCellContent,
}) => {
  const { isSellerOrClient } = useEstimateEditorSettings();
  const { columns } = useEstimateTableSettings();
  const structure = useEstimateStructure();
  const { settings, visibility, hideAllPrices } = structure;
  const { hasTeamMembersCol, hasTimeCol, currency, companyCurrency } = settings;
  const {
    apply,
    hideSummaryTime,
    hideSummaryTeam,
    hideSummaryHours,
    hideSummaryRate,
    hideSummaryCost,
  } = visibility;
  
  return <>
    {
      columns.map((column, index) => {
        const columnProps = {
          displayCellContent,
          extendPadding: index === columns.length-1,
          navigationKey: `sm-${column.name}`
        }
        switch(column.name) {
          case SummaryColumns.HOURS:
            return !(apply && hideSummaryHours) &&
              <HoursCell
                key={ column.name }
                element={ element }
                isWorkType
                { ...columnProps }
              />;
          
          case SummaryColumns.TEAM:
            return !(apply && hideSummaryTeam) && hasTeamMembersCol &&
              <TeamMembersCell
                key={ column.name }
                element={ element }
                { ...columnProps }
              />;
          
          case SummaryColumns.TIME:
            return !(apply && hideSummaryTime) && hasTimeCol &&
              <TimeCell
                key={ column.name }
                element={ element }
                { ...columnProps }
              />;
        }
        
        if(!isSellerOrClient || hideAllPrices)
          return;
        
        switch(column.name) {
          case SummaryColumns.COST:
            return !(apply && hideSummaryCost) &&
              <CostCell
                key={column.name}
                element={element}
                isWorkType
                { ...columnProps }
              />;
            
          case SummaryColumns.RATE:
            return !(apply && hideSummaryRate) &&
              <RateCell
                key={column.name}
                element={element}
                displayClientCellContent={displayClientCellContent}
                { ...columnProps }
              />;
          
          case SummaryColumns.C_COST:
            return <CompanyCostCell
              key={column.name}
              element={element}
              { ...columnProps }
            />
          
          case SummaryColumns.C_UNIT_COST_INNER:
            return <CompanyUnitCostCell
              key={column.name}
              element={element}
              useCompanyCurrency
              { ...columnProps }
            />;
            
          case SummaryColumns.C_UNIT_COST:
            return currency !== companyCurrency &&
              <CompanyUnitCostCell
                key={column.name}
                element={element}
                { ...columnProps }
              />;
            
          case SummaryColumns.C_PROFIT:
            return <ProfitCell
              key={column.name}
              element={element}
              { ...columnProps }
            />;
            
          case SummaryColumns.C_PROFITABILITY:
            return <ProfitabilityCell
              key={column.name}
              element={element}
              { ...columnProps }
            />;
        }
      })
    }
  </>
})

ColumnFactory.propTypes = {
  element: object.isRequired,
  displayCellContent: bool,
  displayClientCellContent: bool,
};
